import { withInstall } from '@bigin/utils'

import Transfer from './src/transfer.vue'

export const BTransfer = withInstall(Transfer)
export default BTransfer

export * from './src/transfer'
